export enum DocumentPropertyType {
  TEXT = 'text',
  NUMBER = 'number',
  ENUM = 'enum',
  DATE = 'date',
  ARRAY = 'array',
  OBJECT = 'object',
}
